import { useCallback } from 'react';
import { notify } from '@app/ui';
import { RtkqSpin } from '@app/base';
import { useNavigate } from 'react-router-dom';
import { useLazyGetEncounterByAppointmentEventIdQuery } from '@app/medical-record/api';
import { delay } from '@app/medical-record/utils';

export function useRedirectToEncounterByAppointmentEvent() {
  const [fetchEncounter] = useLazyGetEncounterByAppointmentEventIdQuery();
  const navigate = useNavigate();

  return useCallback(
    async (appointmentEventId: string) => {
      const onRedirect = async () => {
        for (let retries = 0; retries < 3; ++retries) {
          const encounter = await fetchEncounter({
            appointmentEventId,
            [RtkqSpin]: false,
          }).unwrap();
          if (encounter) {
            notify.success.t('appointments.event.completed');
            navigate(`/encounter/${encounter.id}`);
            return;
          }
          if (retries === 3 && !encounter) {
            notify.error.t('errors.encounter.startFailed');
            return;
          }
          await delay(300);
        }
      };
      await onRedirect();
    },
    [fetchEncounter, navigate],
  );
}
